import exp from "node:constants";
import { Product } from './product.interface';

export interface Voucher {
    code: string;
    description?: string;
    discountType?: DiscountType;
    discountValue?: number;
    maximumAmount?: number;
    minimumSpentRequired?: number;
    id?: string;
    conditions?: DiscountConditions;
    type?: PricingType;
    useTimes?: number;
    remainingUses: number;
    usesLimitPerDay: number;
    usesLimitPerUser?: number | null;
    totalQuantity?: number | null;
    usedQuantity?: number;
    remainingQuantity?: number | null;
    usedDate: Date;
    info?: VoucherInfo[];
    orderId?: string;
    unitsUsed: number;
    voucherCondition: any;
    isApplicable: boolean;
    isApplied: boolean;
    titleVoucher?: string;
    applicableProducts?: Product[];
    descriptionVoucher?: string;
    tags: VoucherTag[];
    collection: VoucherCollection;
    voucherCollection: VoucherCollection;
}

export interface VoucherInfo {
    name: string;
    value: any;
    type: number;
}

export interface DiscountConditions {
    start: Date,
    end: Date,
    userRoles: [],
    excludedUserRoles: string[],
    productIds: number[],
    excludedProductIds: string[],
    categoryIds: number[],
    excludedCategoryIds: number[],
}

export enum DiscountType {
    Percentage,
    FixedAmount,
    Coin
}

export enum PricingType {
    Voucher = 1,
    PricingTable = 2,
}

export interface ProductQuantityCondition {
  sku: string;
  quantity: number;
}

export interface ProductConditionDto {
    productId?: number;
    sku?: string;
    label?: string;
}

export interface LabelsQuantityConditions {
    labels: string;
    quantity: number;
}

export interface CategoryQuantityConditions {
    categoryId: string;
    quantity: number;
}

export interface LabelsConditions {
  labels: string;
}

export interface ApplicableCategoryIds{
  categoryId: string;
}

export interface VoucherCondition {
    productQuantityConditions?: ProductQuantityCondition[];
    applicableCategoryQuantity?: CategoryQuantityConditions[];
    applicableLabelQuantity?: LabelsQuantityConditions[];
    applicableLabels?: LabelsConditions[];
    applicableCategoryIds?: ApplicableCategoryIds[];
}

export interface VoucherTag {
    name: string;
    slug: string;
    active?: boolean;
}

export interface VoucherCollection {
    name: string;
    slug: string;
    index: number;
}

export interface VoucherDiscount {
    description: string;
    discountAmount: number;
    isApplyPreviewPrice: boolean;
    voucherCode: string;
    voucherName: string;
}